<template>
  <a :href="basketUrl"
     class="mini-basket">
    <template v-if="loading">
      <font-awesome-icon icon="spinner"
                         class="icon"
                         spin></font-awesome-icon>
    </template>
    <template v-else>
      <span v-if="label"
            class="mini-basket__label">
        {{ label }}
      </span>
      <font-awesome-icon :icon="['fal', 'shopping-basket']"></font-awesome-icon>
      <BasketItemQuantity
        v-show="count"
        v-model="count"
        class="mini-basket__count">
      </BasketItemQuantity>
    </template>
  </a>
</template>

<script>
import { BasketResource, BasketItemQuantity } from "spiritweb.packages.ecommerce";

export default {
  name: "MiniBasket",
  components: {
    BasketItemQuantity,
  },
  props: {
    basketUrl: {
      type: String,
      default: "/",
    },
    label: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      count: 0,
      loading: false,
    };
  },
  created () {
    this.loading = true;
    BasketResource.getItemCount()
      .then( ( result ) => {
        this.count = result.data;
      } )
      .finally( () => {
        this.loading = false;
      } );
  },
};
</script>

<style lang="less" scoped>
@import "../../Styles/utils/colors.less";

.mini-basket {
  color: #999;
  font-size: 20px;
  text-decoration: none;
  display: inline-block;
  position: relative;
  min-width: 22px;
  transition: color .2s ease-out;

  &:hover {
    color: #666;
  }

  &__label {
    margin-right: 10px;
    font-size: 18px;
  }

  &__count {
    position: absolute;
    top: 2px;
    left: calc( 100% - 13px );
    background-color: @color-accent-1;
    color: #fff;
    border-radius: 100px;
    padding: 5px;
    min-width: 18px;
    width: auto;
    height: 18px;
    font-size: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 500;
  }

  .icon {
    font-size: 20px;
  }

}
</style>
